module.exports = __webpack_public_path__ + "static/media/checkout_page_logo.cb2b1404.svg";